import { ThemeUICSSObject } from '@apia/theme';
import projectAnalysis from './projectAnalysis';
import { semanticSearch } from './semanticSearch';
/* IMPORT HERE */

const design: ThemeUICSSObject = {
  projectAnalysis,
  semanticSearch,
  /* PREPEND HERE */
};

export default design;
